import { createIcon } from '@chakra-ui/icon'
const InheritedPermissionIcon = createIcon({
  viewBox: '0 0 30 30',
  path: (
    <g>
      <defs>
        <style>
          {
            '.st0{fill:none;stroke:#000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10}'
          }
        </style>
      </defs>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M28.1 28.9h-11c-.4 0-.8-.3-.8-.7V17.8c0-.4.3-.7.8-.7h3.5c.3 0 .5.1.7.4l1.1 1.8c.1.2.4.4.7.4h5.1c.4 0 .8.3.8.7v7.9c-.1.2-.5.6-.9.6zM2.4 13.2h10.7c.7 0 1.3-.5 1.3-1.2V6.6c0-.7-.6-1.2-1.3-1.2H8.7c-.4 0-.8-.2-1-.5L6.5 3.5c-.2-.3-.6-.5-1-.5H2.4c-.7 0-1.3.5-1.3 1.2V12c0 .7.6 1.2 1.3 1.2z"
          className="st0"
        />
        <path
          d="M1.7 2.9v-.8c0-.6.6-1 1.3-1h9.5c.7 0 1.3.5 1.3 1v3.3M6.8 15.8v4.9c0 .9.7 1.6 1.6 1.6h5.7"
          className="st0"
        />
        <path
          d="m12.8 20.7 1.3 1.6-1.3 1.6"
          style={{fill:'none',stroke:'#000',strokeWidth:1.5,strokeLinecap:'round',strokeLinejoin:'round',strokeMiterlimit:10}}
        />
      </g>
    </g>
  ),
})

export default InheritedPermissionIcon
